export default "__VITE_PUBLIC_ASSET__608bedd9__"